var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"d91ddd96b04a5c59c177f6b8f0d502eff9266244"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/new-cars";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

let tracesSampleRate;

if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'production') {
  tracesSampleRate = 0.2;
} else if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging') {
  tracesSampleRate = 0.5;
} else {
  tracesSampleRate = 1.0;
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException;

    if (hint.originalException === 'Timeout') return null;

    if (
      error instanceof ReferenceError
      && (
        [
          'Can\'t find variable: $',
          'jQuery',
          'onPageFinished is not defined',
        ].some(msg => error.message.includes(msg))
      )
    ) {
      return null;
    }

    if (
      error instanceof TypeError
    ) {
      return null;
    }

    if (
      error instanceof SyntaxError
      && (
        [
          'dytmpl',
          'invalid group specifier name',
        ].some(msg => error.message.includes(msg))
      )
    ) {
      return null;
    }

    if (error instanceof DOMException && error.name === 'QuotaExceededError') {
      return null;
    }

    return event;
  },

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
